import { Img } from "@/components/shared/Img";
import { PhotoCredit } from "@/components/shared/PhotoCredit";
import { PhotoNumberTag } from "@/components/shared/PhotoNumber";
import { cn } from "@/lib/utils";

/**
 * A photograph with its words laid on top: a soft ink gradient along the bottom edge and the caption in display type,
 * so the text sits on the picture instead of under it. Without a caption it is just the picture (plus the photo credit, if any).
 */
export const CaptionedFigure = ({ src, caption, alt = "", width = 1200, sizes, imgClassName, className, radius = "rounded-[12px]", onClick, testId, children }) => {
  const Wrapper = onClick ? "button" : "div";
  return (
    <figure className={cn("relative m-0", className)} data-testid={testId}>
      <Wrapper type={onClick ? "button" : undefined} onClick={onClick} aria-label={onClick ? caption || alt || "Opne bilete" : undefined}
        className={cn("img-hover relative block w-full overflow-hidden bg-secondary", radius, onClick && "cursor-zoom-in focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2")}>
        <Img src={src} alt={alt || caption || ""} width={width} sizes={sizes} className={cn("w-full object-cover", imgClassName)} />
        {caption ? (
          <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/80 via-ink/40 to-transparent px-5 pb-4 pt-16 text-left sm:px-6 sm:pb-5" data-testid={testId ? `${testId}-caption` : undefined}>
            <span className="block max-w-prose font-display text-[15px] font-medium leading-snug tracking-[-0.01em] text-paper [text-shadow:0_1px_12px_rgba(0,0,0,.4)] sm:text-[17px]">{caption}</span>
            <PhotoCredit src={src} className="mt-1 !text-paper/70" testId={testId ? `${testId}-credit` : undefined} />
          </figcaption>
        ) : (
          <PhotoCredit src={src} overlay testId={testId ? `${testId}-credit` : undefined} />
        )}
        <PhotoNumberTag src={src} interactive={!onClick} className="absolute right-2.5 top-2.5" testId={testId ? `${testId}-number` : undefined} />
        {children}
      </Wrapper>
    </figure>
  );
};
